function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_BrBGfc6ZhOmiVa3Z1WnfLotH5vB5iA9k"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1280,
  height: 342
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1221.9999999999998,
  cy: 286.75,
  r: 18.75,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1270.5,
  cy: 334.5,
  r: 14.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1019,
  cy: 145,
  r: 23,
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1222,
  cy: 174.25,
  r: 42.25,
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 952,
  cy: 11,
  r: 50,
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 696.5,
  cy: 105.5,
  r: 40.5,
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1256,
  cy: 11,
  r: 34,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 867.4999999999998,
  cy: 225.5,
  r: 103.5,
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 753.5,
  cy: 305.5,
  r: 23.5,
  fill: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1074,
  cy: 297.5,
  r: 72,
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 1118,
  cy: 119,
  r: 13,
  fill: "currentColor"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 602,
  cy: 89,
  r: 10,
  fill: "currentColor"
});

var SvgBg = function SvgBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 1280 342",
    width: "1280pt",
    height: "342pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_BrBGfc6ZhOmiVa3Z1WnfLotH5vB5iA9k)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg.bb4a861a.svg";
export { ForwardRef as ReactComponent };